$('.announcement-slider').slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnFocus: false,
      pauseOnHover: false
    });
    $('.testimonial-slider').slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnFocus: false,
      pauseOnHover: false
    });
    $('.hero-slider').slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnFocus: false,
      pauseOnHover: false
    });
    $('.hero-mobile-slider').slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnFocus: false,
      pauseOnHover: false
    });

$( ".product-variants .radio:not(.radio-disabled)" ).click(function() {
      $( ".product-variants .radio" ).removeClass("active-variant-btn");
  $( this ).addClass("active-variant-btn");
});

$('.qtybox .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
    }else {
      if(qty > 1) {
        qty--;
      }
    }
    qty = (isNaN(qty))?1:qty;
    $(this).parent('.qtybox').find('.quantity-input').val(qty);
});

jQuery.getJSON('/cart.js', function(cart) {
    if (cart.item_count > 0) {
      $('.item-c-count').addClass('item-c-count-up');
    } else {
      $('.item-c-count').removeClass('item-c-count-up');
    }
});



$('.slick-slipperinfo').slick({
    autoplay: false,
      centerMode: true,
      arrows: false,
      dots:true,
      appendDots: $('.dots-slipperinfo'),
  rows: 0,
  pauseOnFocus: false,
      pauseOnHover: false
  });



jQuery( ".fl-new-in" ).click(function(e) {
      jQuery(".new-in-m-o").css("background-color","#e3e4e2");
      jQuery(".fl-new-in").css("border-bottom","none");
      	jQuery(".fl-new-in .li-i-v, .fl-new-in .li-i-h" ).hide();
  		jQuery(".sm-new-in").show();
      jQuery( ".fl-new-in .go-link-new-in" ).wrap('<a href="https://thesmallhome.co.uk/collections/new-in" />')
	});
    
    jQuery( ".sl-new-in-new-collections" ).click(function() {
  		jQuery(".sm-new-in-new-collections").show();
      jQuery( ".sl-new-in-new-collections .go-link-new-in-new-collections" ).wrap('<a href="https://thesmallhome.co.uk/collections/new-season-collection" />')
    });
    
    jQuery( ".sl-new-in-new-edits" ).click(function() {
  		jQuery(".sm-new-in-new-edits").show();
      jQuery( ".sl-new-in-new-edits .go-link-new-in-new-edits" ).wrap('<a href="https://thesmallhome.co.uk/collections/new-season-edits" />')
    });




jQuery( ".fl-sheepskin-slippers" ).click(function(e) {
      jQuery(".sheepskin-slippers-m-o").css("background-color","#e3e4e2");
      jQuery(".fl-sheepskin-slippers").css("border-bottom","none");
      	jQuery(".fl-sheepskin-slippers .li-i-v, .fl-sheepskin-slippers .li-i-h" ).hide();
  		jQuery(".sm-sheepskin-slippers").show();
      jQuery( ".fl-sheepskin-slippers .go-link-sheepskin-slippers" ).wrap('<a href="https://thesmallhome.co.uk/collections/slippers" />')
	});
    
    jQuery( ".sl-sheepskin-slippers-womens" ).click(function() {
  		jQuery(".sm-sheepskin-slippers-womens").show();
      jQuery( ".sl-sheepskin-slippers-womens .go-link-sheepskin-slippers-womens" ).wrap('<a href="https://thesmallhome.co.uk/collections/womens-sheepskin-slippers" />')
    });
    
    jQuery( ".sl-sheepskin-slippers-mens" ).click(function() {
  		jQuery(".sm-sheepskin-slippers-mens").show();
      jQuery( ".sl-sheepskin-slippers-mens .go-link-sheepskin-slippers-mens" ).wrap('<a href="https://thesmallhome.co.uk/collections/mens-sheepskin-slippers" />')
    });

    jQuery( ".sl-sheepskin-slippers-childrens" ).click(function() {
  		jQuery(".sm-sheepskin-slippers-childrens").show();
      jQuery( ".sl-sheepskin-slippers-childrens .go-link-sheepskin-slippers-childrens" ).wrap('<a href="https://thesmallhome.co.uk/collections/childrens-sheepskin-slippers" />')
    });

    jQuery( ".sl-sheepskin-slippers-info" ).click(function() {
  		jQuery(".sm-sheepskin-slippers-info").show();
      jQuery( ".sl-sheepskin-slippers-info .go-link-sheepskin-slippers-info" ).wrap('<a href="https://thesmallhome.co.uk/pages/slipper-information-process-design" />')
    });




jQuery( ".fl-women" ).click(function(e) {
      jQuery(".women-m-o").css("background-color","#e3e4e2");
      jQuery(".fl-women").css("border-bottom","none");
      	jQuery(".fl-women .li-i-v, .fl-women .li-i-h" ).hide();
  		jQuery(".sm-women").show();
      jQuery( ".fl-women .go-link-women" ).wrap('<a href="https://thesmallhome.co.uk/collections/women" />')
	});
    
    jQuery( ".sl-women-footwear" ).click(function() {
  		jQuery(".sm-women-footwear").show();
      jQuery( ".sl-women-footwear .go-link-women-footwear" ).wrap('<a href="https://thesmallhome.co.uk/collections/womens-footwear" />')
    });

    jQuery( ".sl-women-clothing" ).click(function() {
  		jQuery(".sm-women-clothing").show();
      jQuery( ".sl-women-clothing .go-link-women-clothing" ).wrap('<a href="https://thesmallhome.co.uk/collections/womens-clothing" />')
    });

    jQuery( ".sl-women-accessories" ).click(function() {
  		jQuery(".sm-women-accessories").show();
      jQuery( ".sl-women-accessories .go-link-women-accessories" ).wrap('<a href="https://thesmallhome.co.uk/collections/womens-accessories" />')
    });

    jQuery( ".sl-women-jewellery" ).click(function() {
  		jQuery(".sm-women-jewellery").show();
      jQuery( ".sl-women-jewellery .go-link-women-jewellery" ).wrap('<a href="https://thesmallhome.co.uk/collections/womens-jewellery" />')
    });



jQuery( ".fl-homeware" ).click(function(e) {
      jQuery(".homeware-m-o").css("background-color","#e3e4e2");
      jQuery(".fl-homeware").css("border-bottom","none");
      	jQuery(".fl-homeware .li-i-v, .fl-homeware .li-i-h" ).hide();
  		jQuery(".sm-homeware").show();
      jQuery( ".fl-homeware .go-link-homeware" ).wrap('<a href="https://thesmallhome.co.uk/collections/homeware" />')
	});
    
    jQuery( ".sl-homeware-tableware" ).click(function() {
  		jQuery(".sm-homeware-tableware").show();
      jQuery( ".sl-homeware-tableware .go-link-homeware-tableware" ).wrap('<a href="https://thesmallhome.co.uk/collections/tableware" />')
    });

    jQuery( ".sl-homeware-bath" ).click(function() {
  		jQuery(".sm-homeware-bath").show();
      jQuery( ".sl-homeware-bath .go-link-homeware-bath" ).wrap('<a href="https://thesmallhome.co.uk/collections/bath-mats-towels-accessories" />')
    });

    jQuery( ".sl-homeware-living" ).click(function() {
  		jQuery(".sm-homeware-living").show();
      jQuery( ".sl-homeware-living .go-link-homeware-living" ).wrap('<a href="https://thesmallhome.co.uk/collections/home-comforts" />')
    });



    jQuery( ".fl-gifts" ).click(function(e) {
      jQuery(".gifts-m-o").css("background-color","#e3e4e2");
      jQuery(".fl-gifts").css("border-bottom","none");
      	jQuery(".fl-gifts .li-i-v, .fl-gifts .li-i-h" ).hide();
  		jQuery(".sm-gifts").show();
      jQuery( ".fl-gifts .go-link-gifts" ).wrap('<a href="https://thesmallhome.co.uk/collections/gifts" />')
	});


    jQuery( ".fl-sale" ).click(function(e) {
      jQuery(".sale-m-o").css("background-color","#e3e4e2");
      jQuery(".fl-sale").css("border-bottom","none");
      	jQuery(".fl-sale .li-i-v, .fl-sale .li-i-h" ).hide();
  		jQuery(".sm-sale").show();
      jQuery( ".fl-sale .go-link-sale" ).wrap('<a href="https://thesmallhome.co.uk/collections/outlet" />')
	});
    
    
    jQuery( ".fl-explore" ).click(function(e) {
      jQuery(".explore-m-o").css("background-color","#e3e4e2");
      jQuery(".fl-explore").css("border-bottom","none");
      jQuery(".fl-explore .li-i-v, .fl-explore .li-i-h" ).hide();
  		jQuery(".sm-explore").show();
	});


jQuery( ".show-filters-btn" ).click(function(e) {
      jQuery(this).toggleClass("btn-active");
      jQuery(".show-sorting-btn").removeClass("btn-active");
      jQuery(".faceted-filters").toggleClass("fs-hidden");
      jQuery(".collection-sorting__wrapper").addClass("fs-hidden");
	});
jQuery( ".show-sorting-btn" ).click(function(e) {
      jQuery(this).toggleClass("btn-active");
      jQuery(".show-filters-btn").removeClass("btn-active");
      jQuery(".collection-sorting__wrapper").toggleClass("fs-hidden");
      jQuery(".faceted-filters").addClass("fs-hidden");
	});



jQuery( ".collection-read-more" ).click(function(e) {
  e.preventDefault();
  jQuery(this).hide();
  jQuery(".read-more-text").show();
});